import { render, staticRenderFns } from "./BridgeTransfer.vue?vue&type=template&id=45c195ce&scoped=true"
import script from "./BridgeTransfer.vue?vue&type=script&lang=js"
export * from "./BridgeTransfer.vue?vue&type=script&lang=js"
import style0 from "./BridgeTransfer.vue?vue&type=style&index=0&id=45c195ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c195ce",
  null
  
)

export default component.exports